var CategoryAPI = require("../../api").Category;
var Promise = require("bluebird");
var _ = require("underscore");

var items = {
  Keywords: ['keywords'],
  Reference: ['reference'],
  Location: ['radius','searchArea','searchSort'],
  ProjectType: ['projectType'],
  AmountSought: ['amountSoughtType','amountSoughtMax','amountSoughtMin','amountSoughtValue'],
  AmountRaised: ['amountRaisedFormat','amountRaisedType','amountRaisedMax','amountRaisedMin','amountRaisedValue'],
  income: ['incomeType','incomeMax','incomeMin','incomeValue'],
  FundingRequiredDate: ['dateFundingRequiredType','dateFundingRequiredMax','dateFundingRequiredMin','dateFundingRequiredValue'],
  DateOfCompletion: ['dateOfCompletionType','dateOfCompletionMax','dateOfCompletionMin','dateOfCompletionValue'],
  fullyfunded: ['fullyfunded'],
  CharitableCategories: ['category']
}

 angular
  .module("app.directives")
  .directive("projectFilters", function () {
    return {
      restrict: "E",
      scope: {
        query: "=",
        change: "&",
      },
      replace: true,
      template: require("./template.pug"),
      link: function (scope, element, attrs) {
        var change = scope.change();
        scope.query = scope.query || {};
        scope.selectedItems = {};

        scope.init = function () {

          for (var key in items) {
            var params = items[key];
            params.forEach(function(pkey){
              if (typeof scope.query[pkey] === 'undefined') return;
              scope.selectedItems[key] = true;
            })
          }

          return CategoryAPI.GetTopLevelCategories().then(function (results) {
            scope.categories = results.map(function(c){
              c.id = c.id.toString()
              return c
            })

          });
        };

        scope.init();

        scope.add = function () {
          var exists = scope.isSelected(scope.itemToAdd);
          if (exists) return false;
          scope.selectedItems[scope.itemToAdd] = true;
          scope.itemToAdd = "";
        };

        scope.remove = function (str) {
          delete scope.selectedItems[str];

          // reset params
          var params = items[str];
          params.forEach(function(key){
            delete scope.query[key]
          })
          scope.search(scope.query);
        };

        scope.search = function(){
          if (scope.canSearch()) {
            change(scope.query);
          }
        }

        scope.canSearch = function(){
          for (var key in scope.selectedItems) {
            return true;
          }
          return false;
        }

        scope.isSelected = function (str) {
          return !!scope.selectedItems[str];
        };

      }
    };
  });
